import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import createStyles from '@material-ui/core/styles/createStyles';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { IUser } from 'interface/user';
import { pushMessage } from 'actionCreators/messages';
import { turnStudentProducer } from 'actionCreators/user';
import { V3_URL } from 'settings';

interface IProps {
  isOpen: boolean;
  setIsOpen: any;
  user: IUser;
  turnStudentProducer?: Function;
  pushMessage?: Function;
}

const useStyles = makeStyles((theme) => {
  return createStyles({
    dialog: {
      minWidth: 530,
      '@media (max-width: 660px)': {
        minWidth: 300,
      },
    },
    title: {
      backgroundColor: 'rgba(236, 239, 241, 1)',
      color: theme.defaultTheme.gray_palette.dark1,
      '& > h2': {
        fontSize: 16,
        fontWeight: 600,
      },
    },
    titleContent: {
      marginTop: 10,
      color: theme.defaultTheme.gray_palette.dark1,
      lineHeight: 1.5,
      '& > h2': {
        fontSize: 16,
        fontWeight: 600,
      },
    },
    btnAcceptAll: {
      backgroundColor: theme.defaultTheme.support_palette.green,
      height: 40,
      color: theme.defaultTheme.support_palette.white,
      padding: 10,
      '& > svg': {
        width: 20,
        height: 20,
        fill: theme.defaultTheme.support_palette.white,
      },
      '&:focus': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      },
      '&:hover': {
        backgroundColor: theme.defaultTheme.support_palette.green,
      },
    },
    btnDisabled: {
      backgroundColor: 'rgba(0, 0, 0, 0.26)',
    },
    closeDialog: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginTop: 34,
      '& > button > span': {
        fontSize: 14,
        textTransform: 'capitalize',
        fontWeight: 700,
      },
    },
    btnClose: {
      color: theme.defaultTheme.gray_palette.dark1,
      marginRight: 10,
    },
  });
});

const TurnProducerDialog = (props: IProps) => {
  const { isOpen, setIsOpen, user, turnStudentProducer, pushMessage } = props;

  const classes = useStyles();

  const closeDialog = () => {
    setIsOpen(false);
  };

  const setInstrutor = async (e: any) => {
    e.preventDefault();
    try {
      await turnStudentProducer({ ...user, type: 1 });
      window.location.href = V3_URL;
    } catch (error) {
      pushMessage('Erro ao salvar os dados!', 'error');
    }
  };

  return (
    <Dialog classes={{ paper: classes.dialog }} open={isOpen}>
      <DialogTitle className={classes.title}>Você gostaria de criar um curso?</DialogTitle>
      <DialogContent>
        <div className={classes.titleContent}>
          Após completar essa ação você se tornará produtor, poderá criar cursos e seu perfil de aluno não será
          alterado. Você poderá acessar tanto o ambiente de aluno como o de produtor.
        </div>
        <div className={classes.closeDialog}>
          <Button onClick={closeDialog} className={classes.btnClose}>
            Cancelar
          </Button>
          <Button onClick={setInstrutor} className={classes.btnAcceptAll}>
            Aceitar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user,
  };
};

export default connect(mapStateToProps, { pushMessage, turnStudentProducer })(TurnProducerDialog);
